/*
  The product page's features (snippets/product-features): a feature's name, or Custom Debossing's
  Learn more, opens its panel (a modal dialog: focus stays inside, Esc closes) instead of leaving the
  page. Without this script each is a link to the page that tells it in full. A click on the dim
  around the panel closes it too.
*/
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-feature]');
  const panel = link && document.getElementById(`feature-${link.dataset.feature}`);
  if (!panel) return;
  event.preventDefault();
  panel.showModal();
});

for (const panel of document.querySelectorAll('dialog.feature')) {
  panel.addEventListener('click', (event) => {
    if (event.target === panel) panel.close();
  });
}
